import {
  THEME_SET,
  THEME_TOGGLE,
} from "../constants/themeConstants";

// Default to light. The store hydrates the real value from localStorage
// in store.js so first paint matches the user's last choice.
const initial = { mode: "light" };

export const themeReducer = (state = initial, action) => {
  switch (action.type) {
    case THEME_SET:
    case THEME_TOGGLE:
      return { ...state, mode: action.payload };
    default:
      return state;
  }
};
